// ─────────────────────────────────────────────────────────────────────────────
//  Доступы (дочерние аккаунты)
//  Добавить в api.js или импортировать отдельно
// ─────────────────────────────────────────────────────────────────────────────

import { clientAxios } from './shared/clientHttp';

// Получить список дочерних аккаунтов
export const APIGetChildAccounts = async () => {
    try {
        const res = await clientAxios.get('/main/api/client/children/');
        return res.data;
    } catch (e) {
        return { status: 'error', detail: e?.response?.data?.message || 'Ошибка загрузки' };
    }
};

// Создать дочерний аккаунт
export const APICreateChildAccount = async (data) => {
    try {
        const res = await clientAxios.post('/main/api/client/children/create/', data);
        return res.data;
    } catch (e) {
        return { status: 'error', detail: e?.response?.data?.message || 'Ошибка создания аккаунта' };
    }
};

// Обновить дочерний аккаунт
export const APIUpdateChildAccount = async (childId, data) => {
    try {
        const res = await clientAxios.patch(`/main/api/client/children/${childId}/update/`, data);
        return res.data;
    } catch (e) {
        return { status: 'error', detail: e?.response?.data?.message || 'Ошибка обновления' };
    }
};

// Удалить (деактивировать) дочерний аккаунт
export const APIDeleteChildAccount = async (childId) => {
    try {
        const res = await clientAxios.delete(`/main/api/client/children/${childId}/delete/`);
        return res.data;
    } catch (e) {
        return { status: 'error', detail: e?.response?.data?.message || 'Ошибка удаления' };
    }
};

// Получить доступные типы прав
export const APIGetAvailablePermissions = async () => {
    try {
        const res = await clientAxios.get('/main/api/client/permissions/');
        return res.data;
    } catch (e) {
        return { permissions: [] };
    }
};